// #region IMPORTS
import { AZFeedback, informUser, TOAST_TYPES } from '@azmed-org/azcomponents';
import React from 'react';

import { useUserMetadata } from '../Auth/useUsermetadata';
import { useAppAuth } from '../Auth/authAdapter';
import { client, ACTIONS } from '../AZFetch';
// #endregion

// #region COMPONENT
/**
 * Thin wrapper around the shared `AZFeedback` component from
 * `@azmed-org/azcomponents`. The library owns the modal, the form and the
 * redux `feedback` slice; the app only provides the current user and the
 * function that persists the feedback (POST to the AZmed data API, like
 * azmonitor).
 *
 * @returns {JSX.Element} The feedback modal
 */
const FeedbackWrapper = () => {
  // #region INITIALIZATION
  const { user } = useAppAuth();
  const { metadata } = useUserMetadata();
  // #endregion

  // #region EVENT
  /**
   * Persist the feedback. The library builds the full payload (userAgent,
   * date, type, attachments, ...) and handles the success/error UI itself.
   *
   * @param {object} feedbackData The feedback payload built by the library
   */
  const handleSendFeedback = async feedbackData => {
    await client
      .post(
        'WebApps_Feedbacker',
        { set: feedbackData },
        { action: ACTIONS.insert },
        null,
        null,
        'production'
      )
      .then(() => {
        informUser({
          title: 'Feedback sent',
          message: 'Thank you for your feedback!',
          type: TOAST_TYPES.success,
        });
      });
  };
  // #endregion

  // #region INTERFACE
  return (
    <AZFeedback
      appName="azviewer"
      userEmail={`${user?.email || 'unknown'}`}
      username={`${metadata?.userName || 'unknown'}`}
      onSendFeedback={handleSendFeedback}
    />
  );
  // #endregion
};
// #endregion

export { FeedbackWrapper };
